import React, {useState, useEffect} from 'react';
import { useForm, Controller} from 'react-hook-form';
import Select from "react-select";
import { NumericFormat } from 'react-number-format';
import DatePicker from 'react-datepicker';
import { it } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import schedulePayService from '../../services/SchedulePayService';

export default function LayerEdit({show,onClose,onFetchEdit,activity}) {
    const { register, control, handleSubmit, reset, watch, getValues, setValue,setError,clearErrors,formState: { errors } } = useForm({});
    const [message, setMessage] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const closeSlide = () => {
        setErrorMsg("");
        setMessage("");
        onClose();
    };

    const handleActionPay= async (data) => {

        const statusFormat = data.status
            ? data.status.value
            : data.status;
        const parAmountFormat = data.partialAmount && String(data.partialAmount).includes(',')
          ? data.partialAmount.replace(/\./g, '').replace(/,/g, '.').replace(/[^\d.-]/g, '')
          : data.partialAmount;
        const payload = {
            ...data,
            partialAmount: Number(parAmountFormat),
            status:statusFormat
        };

       schedulePayService.update(payload,reset)
            .then((res) => {
                setMessage("Pagamento aggiornato con successo!");
                setErrorMsg("");
                onFetchEdit();
            }).catch((error) => {
                console.error("Error update pay: ", error);
                setMessage("");
                setErrorMsg("Errore aggiornamento pagamento. Riprova.");
            }
        );
    }

    useEffect(() => {
        if(activity) {
            reset({
                ...activity,
                startDate: new Date(activity.start_time),
                endDate: new Date(activity.end_time)
            });
        }
    }, [activity, reset]);

    useEffect(() => {
        const subscription = watch((value, { name }) => {
            switch (name) {
                case 'status':
                    break;
                case 'partialAmount':
                    break;
                default: break;
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

  	return (
  	    <div className={`offcanvas offcanvas-end ${show ? "show" : ""}`}>
            <div className="offcanvas-header border-bottom">
                <h5 className="offcanvas-title">Modifica attività</h5>
                <button onClick={closeSlide} className="btn-close text-reset"></button>
            </div>
            <div className="offcanvas-body mx-0 flex-grow-0 p-6 h-100">
                {errorMsg && <div className="mb-6 text-center alert alert-outline-danger">{errorMsg}</div>}
                {message && <div className="mb-6 text-center alert alert-outline-success">{message}</div>}
                <form className="add-new-user pt-0" onSubmit={handleSubmit(handleActionPay)}>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Titolo</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.title ? "is-invalid" : ""}`}>
                                    <i className="bx bx-store" ></i>
                                </span>
                                <Controller
                                    control={control}
                                    name="title"
                                    rules={{ maxLength: {value: 100,message: 'Massimo 100 caratteri' }}}
                                    render={({ field }) => (
                                        <input
                                          {...field}
                                          type="title"
                                          className={`form-control ${errors.store ? "is-invalid" : ""}`}
                                        />
                                    )}
                                />
                            </div>
                            {errors.store && <div className="invalid-input">{errors.store.message}</div>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Inizio</label>
                            <Controller
                                name="startDate"
                                control={control}
                                rules={{ required: 'Data obbligatoria' }}
                                render={({ field, fieldState }) => (
                                    <div>
                                        <DatePicker
                                            locale={it}
                                            placeholderText="gg/mm/aaaa --:--"
                                            selected={field.value}
                                            onChange={field.onChange}
                                            timeIntervals={30}
                                            showTimeSelect
                                            dateFormat="dd/MM/yyyy HH:mm"
                                            className={`form-control ${errors.startDate ? "is-invalid" : ""}`}
                                        />
                                    </div>
                                )}
                            />
                            {errors.startDate && (
                              <div className="invalid-input">{errors.startDate.message}</div>
                            )}
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Fine</label>
                            <Controller
                                name="endDate"
                                control={control}
                                rules={{ required: 'Data obbligatoria' }}
                                render={({ field, fieldState }) => (
                                    <div>
                                        <DatePicker
                                            locale={it}
                                            placeholderText="gg/mm/aaaa --:--"
                                            selected={field.value}
                                            onChange={field.onChange}
                                            timeIntervals={30}
                                            showTimeSelect
                                            dateFormat="dd/MM/yyyy HH:mm"
                                            className={`form-control ${errors.endDate ? "is-invalid" : ""}`}
                                        />
                                    </div>
                                )}
                            />
                            {errors.endDate && (
                              <div className="invalid-input">{errors.endDate.message}</div>
                            )}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Note</label>
                            <Controller
                                control={control}
                                name="notes"
                                rules={{
                                    maxLength: {
                                        value: 512,
                                        message: 'Massimo 512 caratteri'
                                    }
                                }}
                                render={({ field }) => (
                                    <textarea
                                        {...field}
                                        placeholder="Aggiungi una nota..."
                                        className={`form-control ${errors.notes ? "is-invalid" : ""}`}
                                        rows="4"
                                    />
                                )}
                            />
                            {errors.notes && <div className="invalid-input">{errors.notes.message}</div>}
                        </div>
                    </div>
                    {/*
                    <button type="submit" className="btn btn-primary me-3">Invia</button>*/}
                </form>
            </div>
  	    </div>
	);
}